'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Suspense, useState } from 'react';

import { VStack } from '@/components/Layout';
import { Skeleton } from '@/components/ui/skeleton';

import { SupplierProfileHeader } from './-components/SupplierProfileHeader';
import { SupplierFormStore } from './_layout/-store/store';

export const Route = createFileRoute('/_staff/supplier/$supplierId/_layout')({
  component: Layout,
});

function SupplierProfileHeaderSkeleton() {
  return (
    <VStack className="gap-3 bg-neutral-fill px-12 pt-4 shadow-xs pb-4">
      <Skeleton className="h-4 w-40" />
      <VStack className="gap-2">
        <Skeleton className="h-5 w-24 rounded-full" />
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-4 w-48" />
      </VStack>
      <Skeleton className="h-10 w-full" />
    </VStack>
  );
}

function Layout() {
  const [store] = useState(() => SupplierFormStore.createStore());
  return (
    <SupplierFormStore.Provider value={store}>
      <VStack className="gap-0">
        <Suspense fallback={<SupplierProfileHeaderSkeleton />}>
          <SupplierProfileHeader />
        </Suspense>
        <Suspense fallback={<div className="flex-1 px-12 py-5" />}>
          <Outlet />
        </Suspense>
      </VStack>
    </SupplierFormStore.Provider>
  );
}
